<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <OfferForm
          v-model="offer"
          title="Editace nabídky"
          :edit="true"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import OfferForm from '../../../components/forms/OfferForm'

export default {
  name: 'OfferEdit',
  components: {
    OfferForm,
  },
  data() {
    return {
      offer: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadOffer()
  },
  methods: {
    ...mapActions({
      getOffer: 'offer/getOffer',
      updateOffer: 'offer/updateOffer',
    }),
    loadOffer() {
      this.loading = true
      this.getOffer(this.$route.params.offerId)
        .then((response) => {
          this.offer = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save(data) {
      this.saving = true
      this.updateOffer({
        offer: this.offer,
        banner: data.bannerFiles,
        customer: data.customerFiles,
        attachments: data.attachmentsFiles,
      })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
